<template>
  <div class="suspension">
    <van-popup :value="show" style="width: 90%;border-radius: 5px;overflow: visible" @click-overlay="cancel">

      <div class="containers">
       
          <div class="bg"></div>
          <!-- <div class="icon"></div> -->
           <div class="box">
          <div class="title">温馨提示</div>
          <div class="text">
            尊敬的用户您好，请您主动添加专属客服的企业微信。您也可以拨打<span  @click="prepayCalc">{{phone}}</span>
         进行咨询，感谢您的耐心等待！
          </div>
          <img src="@/static/images/zscustomerqrcode.png"/>
          <div class="know"  @click="cancel">我已知晓</div>
        </div>
      </div>

      <!--  -->
    </van-popup>

    <!--  -->
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,

    //
  },
  data() {
    return {
      list: [],
      phone:'4000083336'
      //
    };
  },
  watch: {},
  created() { },
  methods: {
  

   
    // 取消
    cancel() {
      this.$emit('update:show', false);
    },
    prepayCalc(){
      window.location.href = `tel:${this.phone}`;
    },


    //
  },
};
</script>

<style lang="scss" scoped></style>
